// projects/humanresources-personnel/src/assets/i18n/*/hr-per-bank.json
export class HrPerBankKey {
    private static readonly keyPrefix = 'hrPerBank';
    public static title = `${HrPerBankKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerBankKey.keyPrefix}.pageHeader`;
    public static number = `${HrPerBankKey.keyPrefix}.number`;
    public static finAccBankUuid = `${HrPerBankKey.keyPrefix}.finAccBankUuid`;
    public static accountNumber = `${HrPerBankKey.keyPrefix}.accountNumber`;
    public static iban = `${HrPerBankKey.keyPrefix}.iban`;
    public static paymentWay = `${HrPerBankKey.keyPrefix}.paymentWay`;
    public static amount = `${HrPerBankKey.keyPrefix}.amount`;
    public static genCurrencyUuid = `${HrPerBankKey.keyPrefix}.genCurrencyUuid`;
    public static genMeasureUnitUuid = `${HrPerBankKey.keyPrefix}.genMeasureUnitUuid`;
    public static blockageIndicator = `${HrPerBankKey.keyPrefix}.blockageIndicator`;
    public static blockageMessage = `${HrPerBankKey.keyPrefix}.blockageMessage`;
    public static unBlockageMessage = `${HrPerBankKey.keyPrefix}.unBlockageMessage`;
    public static block = `${HrPerBankKey.keyPrefix}.block`;
    public static unblock = `${HrPerBankKey.keyPrefix}.unblock`;
}
